import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI_INDEX, CMSAPI } from '../../../utils/CmsAPI';
import config from '../../../config';
import { currentDate } from '../../../utils/Helper';

const reset = createAction(types.ACTION_RESET);
const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const resetMoreStoryItems = () => {
  return (dispatch) => {
    dispatch(reset());
  };
};

const fetchData = (item1, item2, item3, item4, item5, item6) => {
  const storyQueryObj = {};
  storyQueryObj.prefixPath = config.lscsPath;
  storyQueryObj.projectName = 'designinspireV2';
  storyQueryObj.max = 6;
  storyQueryObj.sortBy = '+contentPublishDate';
  storyQueryObj.enableDate = false;
  storyQueryObj.q = `(displayStatus:online)%20AND%20(TeamSite/Templating/DCR/Type:=%22Designer Story/Story Items%22) 
  AND ((storyID:${item1}) OR (storyID:${item2}) OR (storyID:${item3}) OR (storyID:${item4}) OR (storyID:${item5}) OR (storyID:${item6}))`;
  const url = CMSAPI_INDEX(storyQueryObj);
  return axiosAdapter({
    url,
  });
};

const massageData = (response) => {
  const responseData = response.data;
  const data = responseData.result.assets;
  const languages = ['en', 'tc', 'sc'];
  const storyCollection = { en: [], tc: [], sc: [] };
  if (!data) {
    throw new Error('no data');
  }

  languages.map((lang) => {
    if (
      responseData.included > 0 &&
      Array.isArray(responseData.result.assets) &&
      responseData.result.assets.length > 0
    ) {
      responseData.result.assets.map((story) => {
        const reference = story['content']['content'];
        if (reference[lang]['coreInfo']['storyTitle']) {
          const item = {};
          // massage item
          item.mainCategory = story['metadata']['mainCategory'];
          item.mainCategory_name = story['metadata'][`mainCategory_${lang}`];
          item.title = reference[lang]['coreInfo']['storyTitle'];
          item.company = reference[lang]['coreInfo']['companyName'];
          item.cover = reference['coverImage_container']['cover_upload'];
          item.type = reference[lang]['coreInfo']['storyType'];
          switch (item.type) {
            case 'storyPage':
              item.url = reference[lang]['page_container']['pageURL'];
              item.abstract = reference[lang]['page_container']['storyAbstract'];
              break;
            case 'videoOnly':
              item.url = reference[lang]['video_container']['videoURL'];
              break;
            case 'fileDownload':
              item.url = reference[lang]['file_container']['filePath'];
              break;
          }

          storyCollection[lang].push(item);
        }
      });
    }
  });

  return storyCollection;
};

const getMoreStoryItems = (item1, item2, item3, item4, item5, item6) => {
  return async (dispatch) => {
    dispatch(requestFetch(item1, item2, item3, item4, item5, item6));
    try {
      const response = await fetchData(item1, item2, item3, item4, item5, item6);
      const data = massageData(response);
      return dispatch(receiveSuccess(data));
    } catch (error) {
      const message = messageError(error);
      dispatch(receiveError(message));
    }
  };
};

const getRandomStoryItems = async (storyID) => {
  try {
    const response = await fetchItemData();
    return massageStoryItemsData(response, storyID);
  } catch (error) {
    throw error;
  }
};

const massageStoryItemsData = (response, storyID) => {
  const responseData = response.data;
  const data = responseData.results.facets[0].values;
  const dataArray = data.filter((item) => item.value != storyID && item.count != 0);

  const randomList = [];
  while (randomList.length < 6) {
    const randomIndex = Math.floor(Math.random() * dataArray.length);
    if (!randomList.includes(randomIndex)) {
      randomList.push(randomIndex);
    }
  }

  const correspondingValues = randomList.map((index) => {
    return dataArray[index].value;
  });

  return correspondingValues;
};

const fetchItemData = () => {
  const storyQueryObj = {};
  storyQueryObj.prefixPath = config.lscsPath;
  storyQueryObj.projectName = 'designinspireV2';
  storyQueryObj.max = 1;
  storyQueryObj.enableDate = false;
  storyQueryObj.q = `(displayStatus:online)%20AND%20(TeamSite/Templating/DCR/Type:=%22Designer Story/Story Items%22)`;
  storyQueryObj.showFacet = `showFacet=storyID&includeDCRContent=false&maxFacet=500`;
  const url = CMSAPI_INDEX(storyQueryObj);
  return axiosAdapter({
    url,
  });
};

const fetchMainPageData = (pageName, pageType) => {
  const url = CMSAPI(
    config.lscsPath,
    pageName,
    pageType,
    config.cmsProjectName,
    true,
    currentDate().getTime(),
  );
  return axiosAdapter({
    url,
  });
};

const massageMainPageData = (response) => {
  const responseData = response.data;
  const data = responseData.result.assets[0];
  if (!data) {
    throw new Error('no data');
  }
  return data;
};

const getStoryMainPage = async (pageName, pageType) => {
  try {
    const response = await fetchMainPageData(pageName, pageType);
    return massageMainPageData(response);
  } catch (error) {
    throw error;
  }
};

export { getMoreStoryItems, getRandomStoryItems, getStoryMainPage, resetMoreStoryItems };
